import React from "react";

import { Text } from "@performyard/py-components";

type WizardStepWrapperProps = {
	title: string;
	subtitle: string;
	children?: React.ReactNode;
};

export const WizardStepWrapper = ({ title, subtitle, children }: WizardStepWrapperProps) => {
	return (
		<div className="flex flex-col items-center">
			<Text size="sub-heading" weight="semi-bold" color="neutral-9" dangerouslySetClassName="text-center">
				{title}
			</Text>
			<Text size="paragraph-2" color="neutral-9" dangerouslySetClassName="text-center">
				{subtitle}
			</Text>
			{children && <div className="mt-8 w-full max-w-[512px]">{children}</div>}
		</div>
	);
};
